import { call, put } from 'redux-saga/effects';
import ActionTypes from '../actionTypes';

export function* getAllJobs(action): Generator<any, void, empty> {
  const actionId = action?.id || 'me';

  try {
    const response = yield call(() => APIService.apiRequest('GET_JOBS', 'GET', {
      routeParams: {
        id: action?.id,
      },
      query: {
        page: action?.page ?? 0,
      },
    }));

    yield put({
      type: ActionTypes.job.getAllJobs.SUCCESS,
      id: actionId,
      page: action?.page,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.job.getAllJobs.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* postJob(action): Generator<any, void, empty> {
  const actionId = action?.id;
  try {
    const response = yield call(() => APIService.apiRequest('POST_JOB', 'POST', {
      body: action?.body ?? {},
    }));
    yield put({
      type: ActionTypes.jobItem.postJob.SUCCESS,
      id: response?._id,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.jobItem.postJob.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* getJob(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_JOB', 'GET', {
      routeParams: {
        id: action?.id,
      },
    }));
    yield put({
      type: ActionTypes.jobItem.getJob.SUCCESS,
      id: action?.id,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.jobItem.getJob.ERROR,
      error,
    });
  }
}

export function* archive(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_JOB', 'PATCH', {
      routeParams: {
        id: actionId,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.jobItem.archive.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.jobItem.archive.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* patchJob(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_JOB', 'PATCH', {
      routeParams: {
        id: actionId,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.jobItem.patchJob.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.jobItem.patchJob.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* removeJob(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('REMOVE_JOB', 'DELETE', {
      routeParams: {
        id: actionId,
      },
    }));
    yield put({
      type: ActionTypes.job.removeJob.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.job.removeJob.ERROR,
      id: actionId,
      error,
    });
  }
}
